const { BlazeError } = require('@blaze-cms/core-errors');

const DEFAULT_KEY = 'default';

function itemTypeHandler(typeName, typeHandler) {
  const items = new Map();
  const itemOptions = new Map();

  function getOptions(key) {
    return itemOptions.get(key);
  }

  function has(key) {
    return itemOptions.has(key);
  }

  function getDefault() {
    const defaultItem = itemOptions.get(DEFAULT_KEY);
    if (!defaultItem) return null;
    return defaultItem;
  }

  function getAll() {
    return [...itemOptions.entries()].filter(isNotDefaultItem);
  }

  function isNotDefaultItem([itemKey, { key }]) {
    return key === itemKey;
  }

  function add(itemDetails) {
    validate(itemDetails);

    const { key, isDefault = false } = itemDetails;
    const item = { ...itemDetails };
    itemOptions.set(key, item);
    if (isDefault) {
      itemOptions.set(DEFAULT_KEY, item);
    }
  }

  function setDefault(defaultItemKey) {
    if (!itemOptions.has(defaultItemKey)) {
      return;
    }

    const defaultItemOptions = getOptions(defaultItemKey);
    defaultItemOptions.isDefault = true;
    itemOptions.set(DEFAULT_KEY, defaultItemOptions);
  }

  function validate(itemDetails) {
    const { key, type, isDefault } = itemDetails;

    if (!key || !type) throw new BlazeError(`A ${typeName} requires a key and type`);

    const regex = /^[a-z0-9_-]+$/;
    if (!regex.test(key)) {
      throw new BlazeError(`A ${typeName} key should match pattern [a-z0-9_-]`);
    }

    if (itemOptions.has(key))
      throw new BlazeError(`A ${typeName} with the key ${key} has been already added`);
    if (isDefault && itemOptions.has(DEFAULT_KEY)) {
      throw new BlazeError(`Default ${typeName} is already defined`);
    }
    if (!typeHandler.has(type)) {
      throw new BlazeError(`A ${typeName} type "${type}" does not exist`);
    }
  }

  async function get(key = DEFAULT_KEY) {
    if (items.has(key)) return items.get(key);

    const item = key === DEFAULT_KEY ? getDefault() : getOptions(key);
    if (!item) throw new BlazeError(`A ${typeName} "${key}" does not exist`);

    const { type, options } = item;
    const { create } = await typeHandler.get(type);
    const createdItem = await create(options, key);
    items.set(key, createdItem);
    items.set(item.key, createdItem);
    return createdItem;
  }

  return { add, getOptions, getAll, getDefault, get, setDefault, has };
}

module.exports = itemTypeHandler;
